// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Ds-z","landingPageVideo":"Es-z","play":"Fs-z","iframeVideo":"Gs-z","playHidden":"Hs-z","fullwidth":"Is-z"};